

import ProjectOrAppTable from './ProjectOrAppTable';
import DelegationsTable from './DelegationsTable';
import { Box, Grid, Typography } from '@material-ui/core';
import { settingsPageTranslationRef } from '../../translation/settings-page/settings-page';
import { useTranslationRef } from '@backstage/core-plugin-api/alpha';

const PermissionsAndDelegationsTab = () => {
  const projRoles = ['jp', 'developer', 'devops'];
  const appRoles = ['business_manager', 'it_owner'];
  const { t } = useTranslationRef(settingsPageTranslationRef);

  return (
    <Box>
      <Grid container spacing={2} direction="row" alignItems="center" justifyContent="space-between">
        <Grid item xs={12}>
          <Typography variant="h5" gutterBottom>{t("permissions.title")}</Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <ProjectOrAppTable type="project" title={t("permissions.project.title")} rolesNames={projRoles} />
        </Grid>
        <Grid item xs={12} md={6}>
          <ProjectOrAppTable type="application" title={t("permissions.application.title")} rolesNames={appRoles} />
        </Grid>
        <Grid item xs={12}>
          <DelegationsTable />
        </Grid>
      </Grid>
    </Box>
  );
};

export default PermissionsAndDelegationsTab;
